var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择地址","options":_vm.citylist},on:{"change":_vm.cityhandleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }